import { stationMunicipalitiesTypes } from "redux/reducers/stationMunicipalities/stationMunicipalitiesTypes";
import { api_delete, api_post, api_get, PROYECT } from "services/api";
import { startRequestComp, stopRequestComp, setSnackbar } from "../search/searchActions";

const { 
  GET_STATION_MUNICIPALITIES_STATES,
  SET_STATION_MUNICIPALITIES_FILTERS,
  GET_STATION_MUNICIPALITIES,
  CREATE_STATION_MUNICIPALITIES,
  DELETE_STATION_MUNICIPALITIES,
  CLEAR_STATION_MUNICIPALITIES,
  SET_CONFIG_FILTER_STATION_MUNICIPALITIES,
  SET_CONFIG_PAGE_STATION_MUNICIPALITIES,
  SET_CONFIG_PAGE_SIZE_STATION_MUNICIPALITIES,
  SET_CONFIG_SORTED_STATION_MUNICIPALITIES,
} = stationMunicipalitiesTypes

export const getStatesWithMunicipalities = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/locations/states/with_municipalities`
  return async( dispatch ) => {
    dispatch(startRequestComp('loadingStationMunicipalities'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_STATION_MUNICIPALITIES_STATES,
        payload: resp
      })
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingStationMunicipalities'))
  }
}

export const getAllStationMunicipalities = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/locations/station_municipalities`
  return async( dispatch ) => {
    dispatch(startRequestComp('loadingStationMunicipalities'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_STATION_MUNICIPALITIES,
        payload: resp
      })
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingStationMunicipalities'))
  }
}

export const getStationMunicipalities = (stationID) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/locations/station_municipalities/by_station/${stationID}`
  return async( dispatch ) => {
    dispatch(startRequestComp('loadingStationMunicipalities'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_STATION_MUNICIPALITIES,
        payload: resp
      })
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingStationMunicipalities'))
  }
}

export const createNewStationMunicipalities = (form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/locations/station_municipalities`
  return async ( dispatch ) => {
    dispatch(startRequestComp('loadingStationMunicipalities'))

    await api_post(url, form).then(() => {
      dispatch({
        type: CREATE_STATION_MUNICIPALITIES,
        payload: form
      })
      dispatch(setSnackbar('El municipio se ha guardado con éxito', 'success'))
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingStationMunicipalities'))
  }
}

export const deleteStationMunicipalities = (form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/locations/station_municipalities`
  return async ( dispatch ) => {
    dispatch(startRequestComp('loadingStationMunicipalities'))

    await api_delete(url, form).then(() => {
      dispatch({
        type: DELETE_STATION_MUNICIPALITIES,
        payload: form
      })
      dispatch(setSnackbar('El municipio se ha eliminado con éxito', 'success'))
    }).catch(error => dispatch(setSnackbar(error ? error : "Error contacte al administrador")))
    dispatch(stopRequestComp('loadingStationMunicipalities'))
  }
}

export const clearStationMunicipalities = () => ({
  type: CLEAR_STATION_MUNICIPALITIES,
})

export const setStationMunicipalitiesFilters = (key = "", data) => ({
  type: SET_STATION_MUNICIPALITIES_FILTERS,
  payload: { data, key }
})

export const setConfigPageStationMunicipalities = (page) => ({
  type: SET_CONFIG_PAGE_STATION_MUNICIPALITIES,
  payload: page,
})

export const setConfigPageSizeStationMunicipalities = (pageSize) => ({
  type: SET_CONFIG_PAGE_SIZE_STATION_MUNICIPALITIES,
  payload: pageSize,
})

export const setConfigFilterStationMunicipalities = (filter) => ({
  type: SET_CONFIG_FILTER_STATION_MUNICIPALITIES,
  payload: filter,
})

export const setConfigSortedStationMunicipalities = (sort) => ({
  type: SET_CONFIG_SORTED_STATION_MUNICIPALITIES,
  payload: sort,
})